import { Component, inject, Input } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MiddlewareService } from '../../core/services/middleware.service';
import { apiURL } from '../../../assets/data/api-url';
import { ValidationMessageComponent } from '../../shared/components/validation-message/validation-message.component';
import { CaptchaComponent } from '../../shared/components/captcha/captcha.component';
import { ApiResponse } from '../../core/enums/api-response.enum';
import { ModalType } from '../../core/enums/modal-type.enum';
import { ModalService } from '../../core/services/modal.service';
import { globalDatas } from '../../../assets/data/globals';
import { NoArabicInputDirective } from '../../shared/directives/no-arabic-input.directive';
import { AlphabetsAndSpaceOnlyDirective } from '../../shared/directives/alphabets-and-space-only.directive';
import { Subscription } from 'rxjs';
import { EncryptionService } from '../../core/services/encryption.service';

@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [
    TranslateModule,
    ReactiveFormsModule,
    ValidationMessageComponent,
    CaptchaComponent,
    NoArabicInputDirective,
    AlphabetsAndSpaceOnlyDirective
  ],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent {
  @Input() isLanding: boolean = false;
  isSubmitted = false;
  showCaptcha = false;
  private _middlewareService = inject(MiddlewareService);
  private formSubscription: Subscription | null = null;
  
  constructor(
    public modalService: ModalService,
    private translate: TranslateService,
    private encryptionService: EncryptionService
  ) { }

  contactForm: FormGroup = new FormGroup({
    contactUsFirstName: new FormControl('', Validators.required),
    contactUsLastName: new FormControl(''),
    contactUsEmail: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern(globalDatas.EMAIL_REG_EXP),
    ]),
    contactUsMessage: new FormControl('', Validators.required),
  });

  ngOnInit(): void {
    this.formSubscription = this.contactForm.valueChanges.subscribe((value) => {
      if (this.showCaptcha) {
        this.showCaptcha = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.formSubscription?.unsubscribe();
  }

  contactUs() {
    this.isSubmitted = true;
    if (this.contactForm.valid) {
      this.showCaptcha = true;
    }
  }

  onContactUsClick() {
    if (this.contactForm.valid) {
      const encryptedPayload = this.encryptionService.encryptData({
        firstName: this.contactForm?.controls['contactUsFirstName'].value,
        lastName: this.contactForm?.controls['contactUsLastName'].value,
        email: this.contactForm?.controls['contactUsEmail'].value,
        description: this.contactForm?.controls['contactUsMessage'].value,
        selectedLanguage: this.translate.currentLang,
      });
      this._middlewareService
        .callPostMiddleware(apiURL.contactUS, { payload: encryptedPayload })
        .subscribe(
          (res) => {
            this.contactForm.reset();

            if (res?.code === ApiResponse.OK) {
              this.modalService.commonAlertModal(
                'ERROR_MESSAGES.SUCCESS_MESSAGE',
                ModalType.SUCCESS
              );
              this.isSubmitted = false;
              this.showCaptcha = false;
            }
          }
        );
    }
  }

  handleRecaptchaResponse(response: boolean) {
    if (response) {
      this.onContactUsClick();
    }
  }
}
